/**
 * Set your nunjucks variables here
 */

const ENVIRONMENT = process.env.NODE_ENV || process.env.ENVIROMENT || 'staging'

/** Default */
const config = {
  publicPath: 'https://smg-tnew-template.s3.amazonaws.com/qa',
  science: {},
  mediamus: {},
  industry: {},
  railway: {},
  locomotion: {},
  sip: {}
}

Object.keys(config).forEach((museum) => {
  const c = config[museum] || {}

  // Science museum specific config
  if (museum === 'science') {
    c.title = 'Science Museum'
    c.bodyclass = 'mus-science'
  }
  // Science and media museum specific config
  if (museum === 'mediamus') {
    c.title = 'National Science and Media Museum'
    c.bodyclass = 'mus-mediamus'
  }
  // Science and industry museum specific config
  if (museum === 'industry') {
    c.title = 'Science and Industry Museum'
    c.bodyclass = 'mus-industry'
  }
  // Railway museum specific config
  if (museum === 'railway') {
    c.title = 'National Railway Museum'
    c.bodyclass = 'mus-railway'
  }
  // Locomotion museum specific config
  if (museum === 'locomotion') {
    c.title = 'Locomotion'
    c.bodyclass = 'mus-locomotion'
  }
    // Science and Innovation Park museum specific config
    if (museum === 'sip') {
      c.title = 'Science and Innovation Park'
      c.bodyclass = 'mus-sip'
    }

  // General config
  if (ENVIRONMENT === 'production') {
    c.publicPath = 'https://smg-tnew-template.s3.amazonaws.com/live'
  } else if (ENVIRONMENT === 'development') {
    c.publicPath = 'https://localhost:3000'
  } else {
    c.publicPath = 'https://smg-tnew-template.s3.amazonaws.com/qa'
  }
  c.museum = museum

  // Set the global config
  config[museum] = c
})

// General config
if (ENVIRONMENT === 'production') {
  config.publicPath = 'https://smg-tnew-template.s3.amazonaws.com/live'
} else if (ENVIRONMENT === 'development') {
  config.publicPath = 'https://localhost:3000'
} else {
  config.publicPath = 'https://smg-tnew-template.s3.amazonaws.com/qa'
}

module.exports = config
